import { FunctionComponent } from 'react'
import styled from '@emotion/styled'

interface DividerProps {
  dividerTheme?: 'background_is_lighter' | 'background_is_darker'
}

const Divider: FunctionComponent<DividerProps> = ({ dividerTheme = 'background_is_darker' }) => {
  return <StyledDivider dividerTheme={dividerTheme} />
}

const StyledDivider = styled.hr<{ dividerTheme: DividerProps['dividerTheme'] }>`
  height: 1px;
  width: 100%;
  background-color: ${({ dividerTheme }) =>
    dividerTheme === 'background_is_lighter' ? 'var(--beige-300)' : 'var(--neutral-700)'};
  border: none;
`

export default Divider
